import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'myarvato-fake-searchbar',
  imports: [IconFieldModule, InputIconModule, InputTextModule],
  templateUrl: './fake-searchbar.component.html',
  styleUrl: './fake-searchbar.component.scss',
  standalone: true,
})
export class FakeSearchbarComponent {
  @Input() placeholder: string | undefined;
  @Output() OnClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  onMouseClick(event: MouseEvent): void {
    this.OnClick.emit(event);
  }
}
